import React, { useEffect, useState } from "react";
import "../../styles/admins/inventory.css";
import axios from "axios";
import AcceptTicket from "./accept_ticket";
import SolveTicket from "./solve_ticket";

function TechieTickets(props) {
  const [tickets, setTickets] = useState([]);
  const [accept, setAccept] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [showSolve, setShowSolve] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedTkt, setSelectedTkt] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [newCategoryPopup, setNewCategoryPopup] = useState(false);
  const [newCategory, setNewCategory] = useState("");
       const [filterDate, setFilterDate] = useState("");
       const [filterToDate, setFilterToDate] = useState("");
  const [filterStatus, setFilterStatus] = useState("");



  useEffect(() => {
    const getTicketsData = async () => {
      try {
        if (props.clientDetails) {
          const response = await axios.get(
            `https://api.dectwinservices.com/api/techie-tickets/${props.clientDetails.id}/${props.clientDetails.company_id}`
          );
          setTickets(response.data);
          localStorage.setItem("tickets", JSON.stringify(response.data));
        }
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };
    getTicketsData();
  }, [props]);

  const handleShowDetail = (tkt) => {
    setShowDetail(true);
    setSelectedTkt(tkt);
  }

  const handleEditClick = (ticket) => {
    setSelectedTicket(ticket);
    setShowEditModal(true);
  };


  const handleModalChange = (e) => {
    const { name, value } = e.target;
    setSelectedTicket((prev) => ({ ...prev, [name]: value }));
  };


  const handleUpdate = async () => {
      if(selectedTicket.status == ''){
      props.handleToast({
        toastMsg: "Select Ticket status to Update",
        toastColor: "#FF0000",
      }); 
      return;
    }
    try {
      const response = await axios.put(
        `https://api.dectwinservices.com/api/update-ticket/${selectedTicket.ticket_id}`,
        selectedTicket
      );

      if (response.status === 200) {
        // Update local state
        setTickets((prev) =>
          prev.map((t) =>
            t.ticket_id === selectedTicket.ticket_id ? selectedTicket : t
          )
        );
        setShowEditModal(false);
        props.handleToast({
          toastMsg: "Ticket updated successfully!",
          toastColor: "#4CAF50",
        });
      }
    } catch (err) {
      console.error(err);
      props.handleToast({
        toastMsg: "Something went wrong! Please check data or internet.",
        toastColor: "#FF0000",
      });
    }
  };


       const filteredTickets = React.useMemo(() => {
      return tickets.filter((tkt) => {
        // const matchDate =
        //   !filterDate ||
        //   new Date(tkt.create_date).toISOString().slice(0, 10) === filterDate;
  
            const ticketDate = new Date(tkt.create_date);

  const fromDate = filterDate ? new Date(filterDate) : null;
  const toDate = filterToDate ? new Date(filterToDate) : null;

  if (fromDate) {
    fromDate.setHours(0, 0, 0, 0);
  }

  if (toDate) {
    toDate.setHours(23, 59, 59, 999);
  }

  const matchDate =
    (!fromDate || ticketDate >= fromDate) &&
    (!toDate || ticketDate <= toDate);

        const matchStatus =
          !filterStatus ||
          tkt.status?.toLowerCase() === filterStatus.toLowerCase();
  
        return matchDate && matchStatus;
      });
    }, [tickets, filterDate, filterToDate, filterStatus]);
  

  function removeSeconds(dateTime) {
  return dateTime.slice(0, 16);
}
  return (
    <section className="px-32">
       <div className="d-md-flex justify-between">
        <div className="d-flex">
          <i className="bx bxs-show" style={{ fontSize: "24px" }}></i>
          <p className="fw-bolder fs-big">&nbsp;View Ticket Status</p>
        </div>

         <div className="d-md-flex d-sm-flex">

<div className="my-2 px-1">
  <input
              type="date"
              value={filterDate}
              onChange={(e) => setFilterDate(e.target.value)}
              className="form-control"
              title="From Date"
              style={{
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #ccc",
              }}
            />
</div>
<div className="my-2 px-1">
  <input
              type="date"
              value={filterToDate}
              onChange={(e) => setFilterToDate(e.target.value)}
              className="form-control"
            title="To Date"
    min={filterDate || undefined}
      style={{
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #ccc",
              }}
            />
</div>

<div className="my-2 px-1">

            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="form-control"
              style={{
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #ccc",
              }}
            >
              <option value="">All Status</option>
              <option value="Open">Open</option>
              <option value="Closed">Closed</option>
            </select>
</div>

</div>

      </div>
                  <div className="bg-white table-responsive rounded-3">
        <table className="table w-100">
          <thead className="p-3 bg-grey text-center">
              <th className="p-2">Ticket Id</th>
              <th className="p-2">Issue</th>
              <th className="p-2">Category</th>
              <th className="p-2">Priority</th>
              <th className="p-2">Create Date</th>
              <th className="p-2">Solve Date</th>
              <th className="p-2">Status</th>
                    <th className="p-2 text-center">
                <i className="bx bxs-cog rounded-circle bg-grey p-0"></i>
              </th>
          </thead>
              {filteredTickets.map((tkt, index) => (
                <tr key={index} className="text-center">
                  <th className="p-2">{tkt.ticket_inv}</th>
<th className="p-2">
  <div className="line-clamp-2 ">{tkt.title}</div>
</th>
                  <th className="p-2">{tkt.category}</th>
                  <th className="p-2"

                  >
                   <span    style={{
                      // flex: "0.4",
                      backgroundColor: tkt.status != 'Closed' ?
                        tkt.urgency == "1"
                          ? "#FF4C4C"
                          : tkt.urgency == "2"
                            ? "#FFD700"
                            : "#4CAF50"
                            : 'white',
                      color: tkt.status != 'Closed' ? "#fff" : 'black',
                      borderRadius: "4px"
                    }}>  {tkt.urgency == "1"
                      ? "Priority 1"
                      : tkt.urgency == "2"
                        ? "Priority 2"
                        : "Priority 3"}
              </span>    </th>                  <th className="p-2">{removeSeconds(tkt.create_date)}</th>
                  <th className="p-2">{tkt.solve_date ? removeSeconds(tkt.solve_date) : "Pending"}</th>
                  <th className="p-2">{tkt.status}</th>
                  {tkt.status === "Closed" ? (
                    <th
                    className="p-2"
                      style={{
                        display: "flex",
                        // flex: "0.6",
                        justifyContent: "center",
                      }}
                    >
                      <button className="add-btn" style={{ fontSize: "0.8rem" }}
                        onClick={() => handleShowDetail(tkt)}>Solved</button>&nbsp;
                      <button className="add-btn" style={{ fontSize: "0.8rem" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditClick(tkt);
                        }}>Reopen</button>
                    </th>
                  ) : (
                    <th
                      style={{
                        display: "flex",
                        flex: "0.7",
                        justifyContent: "center",
                      }}
                    >
                      {tkt.assigned_to === null ? (
                        <button
                          style={{ fontSize: "0.8rem" }}
                          className="add-btn"
                          onClick={() => {
                            setAccept(tkt);
                            setShowPopup(true);
                          }}
                        >
                          Accept
                        </button>
                      ) : (
                        <button
                          className="add-btn"
                          style={{ fontSize: "0.8rem" }}
                          onClick={() => {
                            setAccept(tkt);
                            setShowSolve(true);
                          }}
                        >
                          View/ Update
                        </button>
                      )}
                    </th>
                  )}
                </tr>
              ))}
          </table>
      </div>
      {showPopup && (
        <AcceptTicket
          onClose={() => setShowPopup(false)}
          ticket={accept}
          tech_id={props.clientDetails.id}
          handleToast={props.handleToast}
        />
      )}
      {showSolve && (
        <SolveTicket
          onClose={() => setShowSolve(false)}
          ticket={accept}
          tech_id={props.clientDetails.id}
          tech_detail={props.clientDetails}
          handleToast={props.handleToast}
        />
      )}

      {showDetail && (
        <>
        <div className="ticket-popup">
          <div className="popup-content" style={{ display: 'block', padding: '1.8em' }}>
            <h3>Ticket Details: ID {selectedTkt.ticket_inv}</h3>


              
<div className="row">

  <div className="form-data col-lg-4 col-md-6 col-12  ticket-column">
    <label>Title</label>
    <div className="input-icon">
      <i className="bx bxs-layer"></i>
      <input type="text" value={selectedTkt.title} readOnly />
    </div>
  </div>

  <div className="form-data col-lg-4 col-md-6 col-12  ticket-column">
    <label>Description</label>
    <div className="input-icon">
      <i className="bx bx-detail"></i>
      <input type="text" value={selectedTkt.description} readOnly />
    </div>
  </div>

  <div className="form-data col-lg-4 col-md-6 col-12  ticket-column">
    <label>Category</label>
    <div className="input-icon">
      <i className="bx bx-category"></i>
      <input type="text" value={selectedTkt.category} readOnly />
    </div>
  </div>

  <div className="form-data col-lg-4 col-md-6 col-12  ticket-column">
    <label>Sub Category</label>
    <div className="input-icon">
      <i className="bx bx-list-ul"></i>
      <input type="text" value={selectedTkt.sub_category} readOnly />
    </div>
  </div>

  <div className="form-data col-lg-4 col-md-6 col-12  ticket-column">
    <label>Priority</label>
    <div className="input-icon">
      <i className="bx bx-error-circle"></i>
      <input type="text" value={selectedTkt.urgency} readOnly />
    </div>
  </div>

  <div className="form-data col-lg-4 col-md-6 col-12  ticket-column">
    <label>Impact Level</label>
    <div className="input-icon">
      <i className="bx bx-trending-up"></i>
      <input type="text" value={selectedTkt.impact_level} readOnly />
    </div>
  </div>

   <div className="form-data col-lg-4 col-md-6 col-12  ticket-column">
    <label>Raised By</label>
    <div className="input-icon">
      <i className="bx bx-user"></i>
      <input type="text" value={selectedTkt.staff_name} readOnly />
    </div>
  </div>

 <div className="form-data col-lg-4 col-md-6 col-12  ticket-column">
            <label>Contact No</label>
<div className="input-icon">
  <i className="bx bx-phone"></i>
  <input
    type="text"
    value={selectedTkt.staff_contact}
    placeholder="Staff Contact"
    readOnly
  />
</div>
            </div>     

             <div className="form-data col-lg-4 col-md-6 col-12  ticket-column">
            <label>Email</label>
<div className="input-icon">
    <i className="bx bx-envelope"></i>
  <input
    type="text"
    value={selectedTkt.staff_email}
    placeholder="Staff Contact"
    readOnly
  />
</div>
            </div>     

  <div className="form-data col-lg-4 col-md-6 col-12  ticket-column">
    <label>Raised On</label>
    <div className="input-icon">
      <i className="bx bx-calendar"></i>
      <input type="text" value={removeSeconds(selectedTkt.create_date)} readOnly />
    </div>
  </div>


  <div className="form-data col-lg-4 col-md-6 col-12  ticket-column">
    <label>Raised Attachment</label>
    <div className="input-icon">
      <i className="bx bx-link"></i>

      {selectedTkt.attachments ? (
        <a
          href={`https://api.dectwinservices.com/uploads/${selectedTkt.attachments}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#007bff", textDecoration: "underline" ,height:'45px',paddingTop:'8px'  }}
        >
          Open Attachment
        </a>
      ) : (
        <span style={{  height:'45px',paddingTop:'8px' }}>No attachment</span>
      )}
    </div>
  </div>

  <div></div>

  <div className="form-data col-lg-4 col-md-6 col-12  ticket-column">
    <label>Solved On</label>
    <div className="input-icon">
      <i className="bx bx-check-circle"></i>
      <input type="text" value={selectedTkt.solve_date ? removeSeconds(selectedTkt.solve_date) : "Pending"} readOnly />
    </div>
  </div>


  
  <div className="form-data col-lg-4 col-md-6 col-12  ticket-column">
    <label>Closing Attachment</label>
    <div className="input-icon">
      <i className="bx bx-link"></i>

      {selectedTkt.solve_attachments ? (
        <a
          href={`https://api.dectwinservices.com/uploads/${selectedTkt.solve_attachments}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#007bff", textDecoration: "underline" ,height:'45px',paddingTop:'8px' }}
        >
          Open Attachment
        </a>
      ) : (
        <span style={{  height:'45px',paddingTop:'8px' }}>No attachment</span>
      )}
    </div>
  </div>

    <div className="form-data col-lg-4 col-md-6 col-12  ticket-column">
    <label>Status</label>
    <div className="input-icon">
      <i className="bx bx-loader-circle"></i>
      <input type="text" value={selectedTkt.status} readOnly />
    </div>
  </div>

  <div className="form-data col-12  ticket-column">
  <label>Engineer Remark</label>

  <div className="input-icon" >
    <i className="bx bx-note"></i>

    <textarea
      value={selectedTkt.resolve_notes || "NA"}
      readOnly
    
    />
  </div>
</div>





</div>

              <br />

                <button
                  className="add-btn"
                  onClick={() => setShowDetail(false)}
                >
                  Go Back
                </button>

            </div>
          </div>
        </>
      )}


      {showEditModal && (
        <div className="ticket-popup">
          <div className="popup-content" style={{ display: 'block', padding: '1em' }}>
            <h3>Edit Ticket</h3>

            <div className="form-data col-12 ">
              <label htmlFor="title">Title/Issue/ Issue</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                <input
                  name="title"
                  value={selectedTicket.title}
                  onChange={handleModalChange}
                />
              </div>
            </div>


            <div className="form-data col-12 " style={{ margin: '0.6em 0em' }}>
              <label htmlFor="description">Ticket Description</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                <textarea
                  name="description"
                  value={selectedTicket.description}
                  onChange={handleModalChange}
                  placeholder="Enter Ticket's Description"
                  required
                />
              </div>
            </div>

            <div className="form-data col-12 " style={{ margin: '0.6em 0em' }}>
              <label htmlFor="category">Category</label>
              <div className="input-icon">
                <i className="bx bxs-category-alt"></i>
                <select
                  name="category"
                  id="category"
                  value={selectedTicket.category}
                  onChange={(e) => {
                    if (e.target.value === "__add_new__") {
                      setNewCategoryPopup(true);
                    } else {
                      handleModalChange(e);
                    }
                  }}
                >
                  <option value="">Select Category</option>
                  <option value={selectedTicket.category}>
                    {selectedTicket.category}
                  </option>
                  <option value="__add_new__">+ Add New Category</option>
                </select>
              </div>
            </div>

            {/* {props.clientDetails == null && selectedTicket.status == 'Closed' && */}
            {/* {selectedTicket.status == 'Closed' && */}
            <div className="form-data col-12 " style={{ margin: '1em 0em' }}>
              <label htmlFor="status">Ticket Status</label>
              <div className="input-icon">
                <i className="bx bxs-check-circle"></i>
                <select
                  name="status"
                  id="status"
                  value={selectedTicket.status}
                  onChange={handleModalChange}
                  required
                >
                  <option value="">Select Status</option>
                  <option value="Open">Open</option>
                  {/* <option value="In Progress">In Progress</option>
      <option value="On Hold">On Hold</option> */}
                  <option value="Closed">Closed</option>
                </select>
              </div>
            </div>
            {/* } */}


            <div className="btn-group d-flex" style={{ justifyContent: "end" }}>
              <button className="add-btn" type="button" onClick={() => setShowEditModal(false)}>
                Cancel
              </button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <button className='add-btn' onClick={handleUpdate}>Update</button>
            </div>
            {/* <div className="modal-actions">
              <button onClick={handleUpdate}>Save</button>
              <button onClick={() => setShowEditModal(false)}>Cancel</button>
            </div> */}

          </div>
        </div>
      )}

      {newCategoryPopup && (
        <div className="ticket-popup">
          <div className="popup-content" style={{ display: 'block', padding: '1.8em' }}>
            <h3>Add New Category</h3>


            <div className="form-data " style={{ margin: '0.8em 0em' }}>
              <label htmlFor="title">Title/Issue/ Issue</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                <input
                  type="text"
                  value={newCategory}
                  onChange={(e) => setNewCategory(e.target.value)}
                  placeholder="Enter new category name"
                />
              </div>
            </div>


            <div className="btn-group d-flex" style={{ justifyContent: "end" }}>
              <button
                onClick={() => {
                  setNewCategoryPopup(false);
                  setNewCategory("");
                }}
                className="add-btn"
              >
                Cancel
              </button>              &nbsp;&nbsp;&nbsp;&nbsp;
              <button
                onClick={() => {
                  if (newCategory.trim()) {
                    setSelectedTicket((prev) => ({
                      ...prev,
                      category: newCategory,
                    }));
                    setNewCategory("");
                    setNewCategoryPopup(false);
                  }
                }}

                className="add-btn"
              >
                Save
              </button>            </div>

          </div>
        </div>
      )}
    </section>



  );
}

export default TechieTickets;

